"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.celebrityCountryMap = void 0;
const celebrityCountryMap = exports.celebrityCountryMap = {
  USA: {
    selectedCountry: {
      market: 'usa',
      code: 'USA',
      defaultCurrency: 'USD',
      language: 'en',
      selectedCurrency: 'USD',
      id: 'USA',
      isoAlpha2Code: 'US',
      officeCode: 'MIA',
      bookingFlag: 'D',
      agencyId: '156393',
      flagPath: '/content/dam/royal/resources/icons/flags/USA.svg',
      marketPath: '/',
      languages: [{
        language: 'en',
        locale: 'en_US',
        seoLocale: 'en_US',
        siteSearchCustomId: '5482866a-a17c-44ff-a78d-64682cc29ade'
      }, {
        language: 'es',
        locale: 'es_PR',
        seoLocale: 'es_US',
        siteSearchCustomId: '99b31d53-a89e-4f5e-9ef6-e582491fd95e'
      }, {
        language: 'fr',
        locale: 'fr_CA',
        seoLocale: 'fr_US'
      }],
      countryName: 'UNITED STATES',
      phoneNumber: '866-562-7625',
      currencies: ['USD']
    }
  },
  GBR: {
    selectedCountry: {
      market: 'gbr',
      code: 'GBR',
      defaultCurrency: 'GBP',
      language: 'en',
      selectedCurrency: 'GBP',
      id: 'gbr',
      isoAlpha2Code: 'GB',
      officeCode: 'LON',
      bookingFlag: 'D',
      agencyId: '156473',
      flagPath: '/content/dam/royal/resources/icons/flags/GBR.svg',
      marketPath: '/gbr/en/',
      languages: [{
        language: 'en',
        locale: 'en_GB',
        seoLocale: 'en_GB',
        siteSearchCustomId: '515fc187-c890-4f21-867f-88281fa0f083'
      }],
      countryName: 'UNITED KINGDOM',
      phoneNumber: '0344 493 4005',
      currencies: ['GBP']
    }
  },
  AUS: {
    selectedCountry: {
      market: 'aus',
      code: 'AUS',
      defaultCurrency: 'AUD',
      language: 'en',
      selectedCurrency: 'AUD',
      id: 'aus',
      isoAlpha2Code: 'AU',
      officeCode: 'AUS',
      bookingFlag: 'D',
      agencyId: '240775',
      flagPath: '/content/dam/royal/resources/icons/flags/AUS.svg',
      marketPath: '/aus/en/',
      languages: [{
        language: 'en',
        locale: 'en_AU',
        seoLocale: 'en_AU',
        siteSearchCustomId: '9f10269f-9034-4c9f-bc5f-eacc7ac2fe5d'
      }],
      countryName: 'AUSTRALIA',
      phoneNumber: '1800 754 500',
      currencies: ['AUD']
    }
  },
  ITA: {
    selectedCountry: {
      market: 'ita',
      code: 'ITA',
      defaultCurrency: 'EUR',
      language: 'it',
      selectedCurrency: 'EUR',
      id: 'ita',
      isoAlpha2Code: 'IT',
      officeCode: 'GEN',
      bookingFlag: 'D',
      agencyId: '310559',
      flagPath: '/content/dam/royal/resources/icons/flags/ITA.svg',
      marketPath: '/ita/it/',
      languages: [{
        language: 'it',
        locale: 'it_IT',
        seoLocale: 'it_IT',
        siteSearchCustomId: '73a64022-2f4b-47a7-85cf-a45b20ad8c15'
      }],
      countryName: 'ITALIA',
      phoneNumber: '01.04.21.82.02',
      currencies: ['EUR']
    }
  },
  ESP: {
    selectedCountry: {
      market: 'esp',
      code: 'ESP',
      defaultCurrency: 'EUR',
      language: 'es',
      selectedCurrency: 'EUR',
      id: 'ESP',
      isoAlpha2Code: 'ES',
      officeCode: 'SPA',
      bookingFlag: 'D',
      agencyId: '192679',
      flagPath: '/content/dam/royal/resources/icons/flags/ESP.svg',
      marketPath: '/esp/es/',
      languages: [{
        language: 'es',
        locale: 'es_ES',
        seoLocale: 'es_ES',
        siteSearchCustomId: '18e44409-ba2a-468c-9cdd-243738f46aa2'
      }],
      countryName: 'SPAIN',
      phoneNumber: '900 374 400',
      currencies: ['EUR']
    }
  },
  FRA: {
    selectedCountry: {
      market: 'fra',
      code: 'FRA',
      defaultCurrency: 'EUR',
      language: 'fr',
      selectedCurrency: 'EUR',
      id: 'fra',
      isoAlpha2Code: 'FR',
      officeCode: 'PAR',
      bookingFlag: 'D',
      agencyId: '386322',
      flagPath: '/content/dam/royal/resources/icons/flags/FRA.svg',
      marketPath: '/fra/fr/',
      languages: [{
        language: 'fr',
        locale: 'fr_FR',
        seoLocale: 'fr_FR',
        siteSearchCustomId: 'b123c59d-64eb-4a6c-9800-565d61971ebb'
      }],
      countryName: 'FRANCE',
      phoneNumber: '0155 278 900 / 805 118 000 (DOM TOM)',
      currencies: ['EUR']
    }
  },
  DEU: {
    selectedCountry: {
      market: 'deu',
      code: 'DEU',
      defaultCurrency: 'EUR',
      language: 'de',
      selectedCurrency: 'EUR',
      id: 'deu',
      isoAlpha2Code: 'DE',
      officeCode: 'FRA',
      bookingFlag: 'D',
      agencyId: '204185',
      flagPath: '/content/dam/royal/resources/icons/flags/DEU.svg',
      marketPath: '/deu/de/',
      languages: [{
        language: 'de',
        locale: 'de_DE',
        seoLocale: 'de_DE',
        siteSearchCustomId: '3b4287e1-f164-494d-898c-b328245ef86b'
      }],
      countryName: 'GERMANY',
      phoneNumber: '00 800 76925227',
      currencies: ['EUR']
    }
  },
  SWE: {
    selectedCountry: {
      market: 'swe',
      code: 'SWE',
      defaultCurrency: 'SEK',
      language: 'sv',
      selectedCurrency: 'SEK',
      id: 'swe',
      isoAlpha2Code: 'SE',
      officeCode: 'OSL',
      bookingFlag: 'D',
      agencyId: '157198',
      flagPath: '/content/dam/royal/resources/icons/flags/SWE.svg',
      marketPath: '/swe/sv/',
      languages: [{
        language: 'sv',
        locale: 'sv_SE',
        seoLocale: 'sv_SE',
        siteSearchCustomId: '080fcfe0-2174-4f3a-a925-b8c78eca38dd'
      }],
      countryName: 'SWEDEN',
      phoneNumber: '0200 88 01 55',
      currencies: ['SEK']
    }
  },
  NOR: {
    selectedCountry: {
      market: 'nor',
      code: 'NOR',
      defaultCurrency: 'NOK',
      language: 'no',
      selectedCurrency: 'NOK',
      id: 'nor',
      isoAlpha2Code: 'NO',
      officeCode: 'OSL',
      bookingFlag: 'D',
      agencyId: '157197',
      flagPath: '/content/dam/royal/resources/icons/flags/NOR.svg',
      marketPath: '/nor/no/',
      languages: [{
        language: 'no',
        locale: 'no_NO',
        seoLocale: 'no_NO',
        siteSearchCustomId: 'dcf19f53-89e1-4fa1-8801-0a049fc48391'
      }],
      countryName: 'NORWAY',
      phoneNumber: '22 51 37 90',
      currencies: ['NOK']
    }
  },
  IRL: {
    selectedCountry: {
      market: 'gbr',
      code: 'IRL',
      defaultCurrency: 'EUR',
      language: 'en',
      selectedCurrency: 'EUR',
      id: 'irl',
      isoAlpha2Code: 'IE',
      officeCode: 'LON',
      bookingFlag: 'D',
      agencyId: '156474',
      flagPath: '/content/dam/royal/resources/icons/flags/IRL.svg',
      marketPath: '/gbr/en/',
      languages: [{
        language: 'en',
        locale: 'en_GB',
        seoLocale: 'en_GB',
        siteSearchCustomId: '515fc187-c890-4f21-867f-88281fa0f083'
      }],
      countryName: 'IRELAND',
      phoneNumber: '1800 932 606',
      currencies: ['EUR']
    }
  },
  BRA: {
    selectedCountry: {
      market: 'bra',
      code: 'BRA',
      defaultCurrency: 'BRL',
      language: 'pt',
      selectedCurrency: 'BRL',
      id: 'bra',
      isoAlpha2Code: 'BR',
      officeCode: 'IBR',
      bookingFlag: 'D',
      agencyId: '386526',
      flagPath: '/content/dam/royal/resources/icons/flags/BRA.svg',
      marketPath: '/bra/pt/',
      languages: [{
        language: 'pt',
        locale: 'pt_BR',
        seoLocale: 'pt_BR'
      }],
      countryName: 'BRASIL',
      phoneNumber: '0800-8913998',
      currencies: ['BRL']
    }
  },
  NZL: {
    selectedCountry: {
      market: 'aus',
      code: 'NZL',
      defaultCurrency: 'NZD',
      language: 'en',
      selectedCurrency: 'NZD',
      id: 'NZL',
      isoAlpha2Code: 'NZ',
      officeCode: 'AUS',
      bookingFlag: 'D',
      agencyId: '282964',
      flagPath: '/content/dam/royal/resources/icons/flags/NZL.svg',
      marketPath: '/aus/en/',
      languages: [{
        language: 'en',
        locale: 'en_AU',
        seoLocale: 'en_AU',
        siteSearchCustomId: '9f10269f-9034-4c9f-bc5f-eacc7ac2fe5d'
      }],
      countryName: 'NEW ZEALAND',
      phoneNumber: '0800-102-123',
      currencies: ['NZD']
    }
  },
  CAN: {
    selectedCountry: {
      market: 'usa',
      code: 'CAN',
      defaultCurrency: 'CAD',
      language: 'en',
      selectedCurrency: 'CAD',
      id: 'CAN',
      isoAlpha2Code: 'CA',
      officeCode: 'MIA',
      bookingFlag: 'D',
      agencyId: '155915',
      flagPath: '/content/dam/royal/resources/icons/flags/CAN.svg',
      marketPath: '/',
      languages: [{
        language: 'en',
        locale: 'en_US',
        seoLocale: 'en_US',
        siteSearchCustomId: '5482866a-a17c-44ff-a78d-64682cc29ade'
      }, {
        language: 'es',
        locale: 'es_PR',
        seoLocale: 'es_US',
        siteSearchCustomId: '99b31d53-a89e-4f5e-9ef6-e582491fd95e'
      }, {
        language: 'fr',
        locale: 'fr_CA',
        seoLocale: 'fr_US'
      }],
      countryName: 'CANADA',
      phoneNumber: '866-562-7625',
      currencies: ['CAD', 'USD']
    }
  }
};